import { createContext } from "react";

const Count=createContext()

export default Count;